export const CONFIG = {
  apiKey: "AIzaSyCZyDC9ByPVER-d7iow9B5Dj5gu08-m40Q",
  authDomain: "pollinsight-6f530.firebaseapp.com",
  databaseURL: "https://pollinsight-6f530-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "pollinsight-6f530",
  storageBucket: "pollinsight-6f530.firebasestorage.app",
  messagingSenderId: "438063724260",
  appId: "1:438063724260:web:c82e3802628d35cc371ef1"
}